var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"mx-2",staticStyle:{"border-radius":"999px"},attrs:{"small":"","depressed":"","dark":"","color":"red"},on:{"click":_vm.onClickBatchDelete}},[_vm._v(" "+_vm._s(_vm._f("t")(_vm.deleteLabel))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }